<template>
  <nav class="project-style-drop w-dropdown-list w--open">
    <div class="color-block">
      <div class="color-block__title">
        {{ $t('Choose project color') }}
      </div>
      <div class="color-grid spacex-8">
        <div
          v-for="color in COLORS"
          :key="color"
          :class="{ 'color-pick-current': color === pickedColor }"
          class="color-pick w-inline-block"
          @click="$emit('color', color)"
        >
          <div :style="{ 'background-color': color }" class="color">
            <div v-if="color === pickedColor" class="icon-check">
              <Icon type="check" color="oncolor" />
              <!--              <CheckIcon class="icon-32px" />-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
  import Icon from '@/components/ui/Icon';

  const COLORS = [
    '#9F0610',
    '#C74C0E',
    '#614E01',
    '#116101',
    '#01615C',
    '#06769F',
    '#296AE1',
    '#7057E9',
    '#495361',
  ];

  export default {
    name: 'ColorEmojiPicker',
    components: {
      Icon,
    },
    props: {
      isColor: Boolean,
      pickedColor: String,
      isEmoji: Boolean,
    },
    data() {
      return {
        COLORS,
      };
    },
  };
</script>
<style lang="scss" scoped>
  .project-style-drop.w--open {
    overflow: auto;
    max-height: 240px;
    margin-top: 12px;
    padding: 12px;
    border-style: solid;
    border-width: 1px;
    border-color: #ececee;
    border-radius: 4px;
    background-color: #fff;
  }
  .color-block {
    margin-bottom: 8px;
  }
  .color-block__title {
    color: #585a5f;
    margin-bottom: 8px;
    font-size: 14px;
    font-weight: 500;
  }
  .color-grid {
    display: -ms-grid;
    display: flex;
    grid-auto-columns: 1fr;
  }
  .color-pick {
    width: 44px;
    height: 44px;
    border-radius: 8px;
    background-color: #ececee;
    -webkit-transition: opacity 200ms ease;
    transition: opacity 200ms ease;
    cursor: pointer;
  }

  .color-pick:hover {
    opacity: 0.8;
  }

  .icon-check {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    width: 16px;
    height: 16px;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
  }
</style>
